import React, { useState } from "react"
import { times } from 'lodash'
import Head from 'next/head'
import InfiniteScroll from 'react-infinite-scroll-component'
import ScrollableAnchor from "react-scrollable-anchor"
import Link from 'next/link'

import HomePageImage from "../HomePageImage"
import LockDisplay from '../../components/LockDisplay'
import { urlParser } from "@/util/imgHelpers"

const BlogGrid = ({
    isMobile,
    blogEntriesData,
    subData
  }) => {

    const blogData = blogEntriesData;
  
    const [itemCount, setItemCount] = useState(10)
    const [hasMore, setHasMore] = useState(true)
  
    const blogCountArray = times(itemCount < blogData.length ? itemCount : blogData.length, Number)
  
    const displayMoreBlogs = () => {
      if (itemCount >= 100) {
        setHasMore(false)
        return
      }
      
      setItemCount((prev) => prev + 10)
    }
    
    const getIsPermitted = (index) => {
      switch (blogData[index].subscriptionRequired) {
        case 'free': return true
        case 'Standard': 
          // eslint-disable-next-line sonarjs/prefer-single-boolean-return
          if (subData.isSubbed) return true
          else return false
        case 'Beyond':
          // eslint-disable-next-line sonarjs/prefer-single-boolean-return
          if (subData.tier === 'Beyond') return true
          else return false
        default: return true
      }
    }
  
    const BlogText = ({ index, isMobile }) => {
        
      const isStandard = blogData[index].subscriptionRequired === 'Standard'
      const lockIconSize = 
        isMobile
        ? 12
        : 16
  
      return (
        <>
          {isMobile ? (
            <div className="blog-preview-text flex flex-col p-5 mb-4">
              <h2 className="cursor-pointer mb-blogText-mob tracking-wider font-soehne-kraftig text-xs">
                <LockDisplay
                  subscriptionRequired={blogData[index].subscriptionRequired}
                  isStandard={isStandard}
                  tag={'SUBSCRIBE'}
                  lockIconSize={lockIconSize} />
  
                {blogData[index].title}
              </h2>
              <hr className="content-divider" />
              <span className="font-soehne-kraftig text-xs text-light">
                {blogData[index].subtitle}
              </span>
              <div>
                <span className="font-soehne-kraftig text-light text-xs tracking-wider">
                  {blogData[index].blogType}{' '}
                </span>
                <span className="font-soehne-kraftig text-light text-xs tracking-wider">
                  BY: {blogData[index].author.toUpperCase()}
                  <br />
                  <span className="font-soehne-kraftig">{blogData[index].datePublished}</span>
                </span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col mt-5">
              <Link 
                href={
                  getIsPermitted(index) 
                  ? `blogs/${blogData[index].blogUrl}` 
                  : '/subscribe' 
                }
                passHref
              >
                <h2 className="cursor-pointer mb-blogText dt-800:mb-4 font-soehne-leight text-3xl dt-800:text-2xl">
                  <LockDisplay
                    subscriptionRequired={blogData[index].subscriptionRequired}
                    isStandard={isStandard}
                    tag={'SUBSCRIBE'}
                    lockIconSize={lockIconSize} />
                  {blogData[index].title}
                </h2>
              </Link>
              <hr className="content-divider" />
              <span className="mb-blogText dt-800:mb-4 font-soehne-xleight text-lg dt-800:text-base">
                {blogData[index].subtitle}
              </span>
              <span className="mb-blogText text-olive opacity-50 dt-800:mb-4 font-soehne-kraftig text-xs">
                {blogData[index].author}
              </span>
              <span className="font-soehne-kraftig text-sm dt-800:text-xs">
                {blogData[index].datePublished}
              </span>
            </div>
          )}
        </>
      )
    }
  
    return (
      <>
        <Head>
          <title>Beyond The Pines</title>
          <meta
            name="description"
            content="Beyond The Pines Magazine: breathtaking photography and visual provocation that stimulates thoughts, ideas, & conversations. "
          />
          <meta
            name="keywords"
            content="Beyond The Pines, Beyond The Pines Magazine, Beyond The Pines Mag, magazine, mag, BTP, BTP magazine, BTP mag, "
          />
        </Head>
        <ScrollableAnchor id='blogs-start'>
          <div className={`${isMobile ? '' : 'mt-height-2 mb-20'}`}>
            <div className='flex w-full'>
              <div className="w-full">
                <InfiniteScroll
                dataLength={itemCount}
                next={displayMoreBlogs}
                hasMore={hasMore}
                loader={<h4>Loading</h4>}
                className="flex flex-wrap"
              >
                {blogCountArray.map((index) => {

                  if (!blogData[index]) return null

                  return (
                    <div key={index} className="blog-preview w-1/3 mb:w-full">
                      <div className="flex mb:flex-col w-full mb-5 mt-5">
                        <Link passHref href={
                          getIsPermitted(index)
                          ? `/blogs/${blogData[index].blogUrl}`
                          : '/subscribe'
                        }>
                          <div className="flex flex-col mb:flex-col">
                            <HomePageImage
                              isMobile={isMobile}
                              src={urlParser(blogData[index].thumbnail, {
                                width: isMobile ? 600 : 800,
                                height: isMobile ? 800 : 1000,
                                format: 'webp',
                                quality: 85
                              })}
                              alt={'Thumbnail for the blog entitled: ' + blogData[index].title}
                              className="
                                blog-preview-image
                                flex-shrink-0
                                dt:w-blogImg
                                cursor-pointer
                                object-cover object-center
                                block
                                mx-auto
                              "
                            />
                            <BlogText index={index} isMobile={isMobile} />
                          </div>
                        </Link>
                      </div>
                    </div>
                  )
                })}
              </InfiniteScroll>
              </div>
            </div>
            
          </div>
        </ScrollableAnchor>
      </>
    )
  }

  export default BlogGrid;
